module.exports = __webpack_public_path__ + "static/media/online-conferences.2603fa60.jpg";